module.exports = __webpack_public_path__ + "static/media/img-empty.fc4e65fb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img-empty.svg
// module id = 948
// module chunks = 0